import { GetStaticProps, NextPage } from 'next'
import dynamic from 'next/dynamic'
import { title } from 'process'
import React from 'react'
// import { Footer } from 'src/components/Footer/Footer'
// import { Breadcrumb } from 'src/components/global/Breadcrumb'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
// import { ThemeOnly } from 'src/components/global/ThemeOnly'
import SkeletonLoading from 'src/components/SkeletonLoading/SkeletonLoading'
import { THEME } from 'src/config/config'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'

const Breadcrumb = dynamic(() => import('src/components/global/Breadcrumb').then((mod) => mod.Breadcrumb), {
  ssr: false,
  loading: () => <SkeletonLoading className="bg-navy" />,
})
const Footer = dynamic(() => import('src/components/Footer/Footer').then((mod) => mod.Footer), {
  ssr: false,
  loading: () => <SkeletonLoading className="bg-navy" />,
})
const ThemeOnly = dynamic(() => import('src/components/global/ThemeOnly').then((mod) => mod.ThemeOnly), {
  ssr: false,
  loading: () => <SkeletonLoading className="bg-navy" />,
})

type Props = object

const FAQ: NextPage<Props> = () => {
  const meta = <Meta title="FAQ/ Instructional Videos" description="FAQ/ Instructional Videos" url="/faq/" />

  return (
    <Main meta={meta}>
      <MainContainer id="mainContainer">
        <div className="flex flex-col bg-clouds">
          <Breadcrumb subject={`FAQ/Instructional Videos`} />
        </div>
        <hr />

        <div style={{ width: '100%', height: '2750px' }}>
          <iframe
            src="https://hub.legaltechnologyhub.com/faq-home"
            width="100%"
            style={{ border: 'none', height: '2750px' }}
            title={title}
          />
        </div>

        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </MainContainer>
    </Main>
  )
}

export default FAQ

export const getStaticProps: GetStaticProps = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }

  return {
    props: {},
    revalidate: 60,
  }
}
